import React from "react";
import "../styles/Footer.css";
import logo from "../assets/logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="site-footer-container">
        {/* Left: Logo + Description */}
        <div className="site-footer-left">
          <img src={logo} alt="Logo" className="site-footer-logo" />
          <p className="site-footer-description">
            We maintain decency in human behavior by showing respect to every patient, their families, and our team.
          </p>
        </div>

        {/* Middle: Navigation Links */}
        <div className="site-footer-links">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/testimonials">Testimonials</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>

        {/* Right: Contact Info + Map */}
        <div className="site-footer-contact">
          <h3>Contact Us</h3>
          <p><strong>📍</strong> Dr.Bharathi Rao's Advanced Comprehensive Rehabilitation Services</p>
          <p><strong>📞</strong> +91 72079 96776</p>
          <p><strong>✉️</strong> info@drbharathiraos.com</p>
          <div className="site-footer-map">
            <iframe
              title="Google Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3929.438759805634!2d78.72350581480001!3d17.331445485998557!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb0b3238ac84b3%3A0x8b9b58e2f5cbe1ce!2sDr.Bharathi%20Rao's%20Advanced%20Comprehensive%20Rehabilitation%20Services!5e0!3m2!1sen!2sin!4v1617774474890!5m2!1sen!2sin"
              allowFullScreen
              loading="lazy"
            ></iframe>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="site-footer-bottom">
        <p>
          © {new Date().getFullYear()} <a href="https://www.linkedin.com/in/madhu-goud-sangulugari-9867b6298/" target="_blank" rel="noopener noreferrer">TechSage</a>. All Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
